import React from 'react';
import { Box, Typography, Tooltip, IconButton, Modal } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';

const InfoModal = ({ title, description, tooltip = 'More Information' }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <span>
      <Tooltip title={tooltip}>
        <IconButton onClick={handleOpen}>
          <InfoIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="info-modal-title"
        aria-describedby="info-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            maxWidth: 400,
            width: '90%',
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography id="info-modal-title" variant="h6" gutterBottom>
            {title}
          </Typography>
          <Typography
            id="info-modal-description"
            variant="body1"
            sx={{ color: '#464646', fontSize: 15 }}
          >
            {description}
          </Typography>
        </Box>
      </Modal>
    </span>
  );
};

export default InfoModal;
